import type {UUID} from './common'
import type {SetAttributeRequest} from './attribute-definition'

export interface RelationshipAssignment {
  relationshipType: string;
  targetIdentityId: UUID;
}

export interface CreateIdentifierRequest {
  identifierType: string;
  identifierValue: string;
  primary: boolean;
}

export interface OnboardingRequest {
  partyId?: UUID | null;
  partyVersion?: number | null;
  partyType?: string | null;
  relationships?: RelationshipAssignment[];
  partyAttributes?: SetAttributeRequest[];
  identityType: string;
  entryDate?: string;
  exitDate?: string;
  identityAttributes?: SetAttributeRequest[];
  identifiers: CreateIdentifierRequest[];
}

/**
 * Response from the composite onboarding endpoint.
 */
export interface Onboarding {
  partyId: UUID;
  partyCreated: boolean;
  identityId: UUID;
  identityType: string;
  lifecycleState: string;
  identifierIds: UUID[];
  partyAttributesSet: number;
  identityAttributesSet: number;
  relationshipIds: Record<string, UUID>;
}

/* eslint-disable i18next/no-literal-string -- field name constants for backend API */
export const OnboardingRequestFields = {
    partyId: 'partyId',
    partyVersion: 'partyVersion',
    partyType: 'partyType',
    partyAttributes: 'partyAttributes',
    relationships: 'relationships',
    identityType: 'identityType',
    identityAttributes: 'identityAttributes',
    entryDate: 'entryDate',
    exitDate: 'exitDate',
    identifiers: 'identifiers',
} as const

export const OnboardingResponseFields = {
    partyId: 'partyId',
    partyCreated: 'partyCreated',
    identityId: 'identityId',
    identityType: 'identityType',
    lifecycleState: 'lifecycleState',
    identifierIds: 'identifierIds',
    partyAttributesSet: 'partyAttributesSet',
    identityAttributesSet: 'identityAttributesSet',
    relationshipIds: 'relationshipIds',
} as const

export const OnboardingIdentifierFields = {
    identifierType: 'identifierType',
    identifierValue: 'identifierValue',
    primary: 'primary',
} as const
/* eslint-enable i18next/no-literal-string */
